import { useContext } from 'react'

import { ViewingProfileContext } from '../../RentalPortalViewingProfile.context'

export function useViewingProfileContext() {
  return useContext(ViewingProfileContext)
}
